module.exports = __webpack_public_path__ + "static/media/monitoria-futura.a6965d41.png";